import React, { useState } from "react";
import client from "@culturehq/client";
import { Loader, Pagination, Warning } from "@culturehq/components";

import { useFetch } from "app/hooks";
import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";
import ErrorMessage from "components/common/ErrorMessage";

import SurveyTable from "./SurveyTable";
import SurveyTableRow from "./SurveyTableRow";
import SurveyAvailable from "./SurveyAvailable";

const SurveysAvailableTable = ({ surveys, onSurveyComplete }) => (
  <SurveyTable>
    {surveys.map(survey => (
      <SurveyTableRow key={survey.id} survey={survey}>
        <td className="actions-cell">
          <SurveyAvailable survey={survey} onSurveyComplete={onSurveyComplete} />
        </td>
      </SurveyTableRow>
    ))}
  </SurveyTable>
);

const SurveysAvailableTableDisplay = ({ surveys, onSurveyComplete }) => {
  if (!surveys || surveys.length === 0) {
    return <Warning>No available surveys.</Warning>;
  }

  return (
    <SurveysAvailableTable
      surveys={surveys}
      onSurveyComplete={onSurveyComplete}
    />
  );
};

const SurveysAvailable = () => {
  const [page, setPage] = useState(1);
  const { error, fetching, json: { surveys = [], pagination }, onUpdate } = useFetch(
    () => client.listProfileAvailableWidgetSurveys({ page }),
    [page]
  );

  const onSurveyComplete = survey => onUpdate(current => ({
    ...current, surveys: current.surveys.filter(currentSurvey => currentSurvey.id !== survey.id)
  }));

  return (
    <>
      <PageHeader title={t("Available surveys")}>
        <Trans>
          Below are the surveys you have left to complete. Your responses are
          important to help improve the culture at your company.
        </Trans>
      </PageHeader>

      {error && <ErrorMessage error={error} />}

      <Loader loading={fetching}>
        {!error && (
          <>
            <SurveysAvailableTableDisplay
              surveys={surveys}
              onSurveyComplete={onSurveyComplete}
            />
            <Pagination {...pagination} onClick={setPage} />
          </>
        )}
      </Loader>
    </>
  );
};

export default SurveysAvailable;
